export const baseUrl = 'http://localhost:8000';
export const environment = 'dev';
export const path = {
    HOME: '/',
    LOGIN: '/login',
    LOG_OUT: '/logout',
    SYSTEM: '/system'
};

export const languages = {
    VI: 'vi',
    EN: 'en'
};
 
export const manageActions = {
    ADD: "ADD",
    EDIT: "EDIT",
    DELETE: "DELETE"
};

export const dateFormat = {
    SEND_TO_SERVER: 'DD/MM/YYYY'
};

export const YesNoObj = {
    YES: 'Y',
    NO: 'N'
}

export const ResponsiveSliderTop = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

 export const responsiveproductlist = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  export const responsiveproductgiftlist = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  export const responsiveproductpage = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  export const settingsSlick = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  export const responsiveproductlistmobile = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3
    }
  };
  export const responsiveproductlistmobile4 = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 4
    }
  };
  export const responsiveproductlistmobile5 = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 5
    }
  };
  export const responsiveproductlist2 = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 2
    }
  };

  export const responsivefunction = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1200 },
      items: 10
    },
    desktop: {
      breakpoint: { max: 1200, min: 1024 },
      items: 8
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 5
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  export const responsive3 = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 3
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  export const categoryCate=[ "be-uong-sua","sua-bot-cac-loai","sua-meiji","sua-aptamil","sua-morinaga","sua-blackmores","sua-nan","sua-glico-icreo","sua-kendamil","sua-snow-baby","sua-danalac","sua-hipp","sua-nubone","sua-purelac","sua-hismart","sua-similac","sua-biostime","sua-abbott-grow","sua-colosbaby","sua-enfa","sua-pediasure","sua-xo","sua-s26","sua-hikid","sua-lotte-kid","sua-de","sua-non-cac-loai","cac-loai-sua-khac","sua-goodhealth","sua-wakodo","sua-i-am-mother","sua-friso","sua-vinamilk","sua-nuoc-cac-loai","binh-sua","binh-sua-pigeon","binh-sua-hegen","binh-sua-philips-avent","binh-sua-comotomo","binh-sua-drbrown-s","binh-sua-nuk","binh-sua-chuchu-baby","binh-sua-wesser","binh-sua-pur","binh-sua-medela","binh-sua-kamidi","num-ty","num-ty-pigeon","num-ty-comotomo","num-ty-pur","num-ty-chuchu-baby","num-ty-drbrown-s","num-ty-philips-avent","dung-cu-tru-sua-ham-sua","binh-u-sua-hop-chia-sua","may-tiet-trung-binh-sua","may-ham-sua","ve-sinh-binh-sua","nuoc-rua-binh-sua","co-rua-binh-sua","be-an-dam","bot-an-dam","bot-an-dam-hipp","bot-an-dam-heinz","bot-an-dam-danalac","bot-an-dam-wakodo","mi-an-dam","my-chao-an-dam","banh-an-dam","banh-an-dam-pigeon","banh-an-dam-gerber","banh-an-dam-maiel-dairies","vang-sua-pho-mai-sua-chua","vang-sua","pho-mai","sua-chua","dinh-duong-dong-lo","thuc-pham-an-dam-khac","dau-o-liu","keo-cho-be","nuoc-yen-cho-be","hat-nem-cho-be","dau-gac","dau-oc-cho","gia-vi-rac-com","nuoc-mam","ruoc-ca-hoi","dung-cu-tap-an-tap-uong","bat-thia-dia","binh-tap-uong","yem-an-cho-be","yem-so-sinh","yem-an-dam","yem-mang","yem-dan-khuy-bam","ghe-an-cho-be","ghe-an-dam-mastela","may-xay","dung-cu-che-bien-an-dam","do-dung-cho-be-an-dam-khac","tui-nhai-chong-hoc","binh-giu-nhiet","be-tam-va-ve-sinh","bim-va-ta-giay-cho-be","bim-dan-ta-dan","bim-quan-ta-quan","bim-merries-ta-merries","bim-moony-ta-moony","bim-pun-ta-pun","bim-huggies-ta-huggies","bim-molfix-ta-molfix","bim-goldgi-ta-goldgi","bim-bobby-ta-bobby","bim-beeboo-ta-beeboo","khan-giay-uot-giay-kho","kem-ham-phan-rom","sua-tam-goi-cho-be","sua-tam-goi-chicco","sua-tam-goi-pigeon","sua-tam-goi-bubchen","do-dung-tam-be","ghe-goi-dau-cho-be","chau-tam-cho-be","khan-mat-khan-tam","chau-rua-mat","do-nhiet-do-nuoc-tam","mu-goi-dau-cho-be","ve-sinh-ca-nhan-cho-be","bo-cho-be","dung-cu-hut-mui-cho-be","ban-chai-kem-danh-rang","dung-cu-ve-sinh-cho-be","be-lot-bon-cau","cham-soc-tai-mui-hong","bot-giat-nuoc-xa-vai","nuoc-giat-dnee","tam-lot-chong-tham","be-mac","do-so-sinh-cho-be","bao-chan-bao-tay","mu-so-sinh-che-thop","ta-vai","quan-ao-so-sinh","ao-so-sinh","quan-so-sinh","bo-quan-ao-so-sinh","bo-body","thoi-trang-be-gai","ao-be-gai","quan-be-gai","vay-be-gai","bo-quan-ao-be-gai","thoi-trang-be-trai","ao-be-trai","quan-be-trai","bo-quan-ao-be-trai","giay-dep-tre-em","giay-tap-di-cho-be","giay-tre-em","xang-dan-dep-tre-em","balo-cho-be","phu-kien-thoi-trang","mu-khan","tat","cap-toc-day-chun-bom","kinh-tre-em","khau-trang-tre-em","phu-kien-khac","be-khoe-va-an-toan","nhiet-ke-cho-be","nhiet-ke-microlife","nhiet-ke-omron","cham-soc-suc-khoe-cho-be","cham-soc-da-cho-be","kem-duong-da","kem-chong-nang","xit-chong-muoi-kem-chong-muoi-cho-be","thiet-bi-bao-ve-an-toan","bit-dau-goi","bit-goc-ban","bit-o-dien","khoa-ngan-keo-tu-lanh","mu-bao-hiem-tre-em","day-dat-tap-di","tu-thuoc-gia-dinh","can-suc-khoe-cho-be","be-choi-va-hoc","do-choi-cho-tre-so-sinh","do-choi-bop-chip-xuc-xac","tham-choi-cho-be","ke-chu-a","gam-nuou-can-rang","ty-ngam","do-choi-treo-noi-cui-xe-day","do-choi-thong-minh","do-choi-hoc-tap","dat-nan-bot-nan","do-choi-am-nhac","do-choi-huong-nghiep","bup-be-thu-bong","thu-bong","bup-be","do-choi-xep-hinh-lap-rap","do-choi-mo-hinh-dieu-khien","do-choi-mo-hinh","do-choi-dieu-khien","do-choi-van-dong","do-choi-go","sach-truyen-dung-cu-hoc-tap","sach-truyen-cho-be","dung-cu-hoc-tap","do-choi-khac","be-ngu","chan-dem-ga-goi","chan","goi","u-ken-nhong-chun","chieu-cho-be","man-chup-cho-be","choang-be","giuong-cui-va-phu-kien","ghe-rung-cho-be","ghe-rung-mastela","ghe-rung-konig-kids","noi-em-be","noi-autoru","be-di-choi-va-van-dong","xe-day","xe-day-seebaby","xe-day-vovo","xe-day-baobaohao","xe-day-combi","xe-cho-be","xe-tap-di","xe-lac-xe-choi-chan","xe-scooter","xe-3-banh","xe-va-phu-kien-van-dong-khac","xe-may-dien-tre-em","diu-dai-cho-be","diu-em-be","dai-di-xe-may","do-boi-cho-be","quan-ao-boi","phao-boi","phu-kien-do-boi","be-boi-phao","danh-cho-me","sua-ba-bau","sua-bau-morinaga","sua-bau-matilia","sua-enfamama","sua-frisomum","dinh-duong-cho-me","sua-cho-nguoi-lon","sua-ensure","may-hut-sua-tui-tru-sua","may-hut-sua-fatzbaby","may-hut-sua-unimom","may-hut-sua-medela","may-hut-sua-philips-avent","may-hut-sua-gluck","tui-tru-sua","thoi-trang-cho-me","do-bo-sau-sinh","quan-lot-bau","ao-lot-cho-con-bu","gen-bung","tui-balo-me-va-be","phu-kien-thoi-trang-cho-me","lam-dep-sau-sinh","do-dung-cho-me-khac","mieng-lot-tham-sua","num-tro-ty","bim-cho-me-sau-sinh","do-dung-khac","do-dung-trong-nha","tu-nhua-cho-be","trang-tri-nha-cua","do-gia-dung","may-phun-suong-tao-am","dung-cu-nha-bep","do-dung-trong-nha-khac","tu-nhua-duy-tan","thung-dung-do","ke-de-do","lan-nhua-gio-dung-do","moc-phoi-quan-ao","nhiet-am-ke","quat-cam-tay"];
  export const Brand=['hipp','canpol-babies','d-nee','arau-baby','omron-healthcare','lactacyd','kabrita','Nutriben-b2276','diana','Maxcare-b2370','philips-avent','lamaze','abbott','bebe-confort','friso','huggies','pampers','The-First-Year-b2346','camry','glico-icreo','lullaby','gerber','mom-s-care','Modilac-b2467','sanosan','richell','vinamilk','Perfect-Purity-b2507','Vtech-b2520','bright-starts','fisher-price','nuk','Tommee-Tippee-b2216','medela','johnson-s','morinaga','Nanny-Vitacare-b2273','seebaby','Vaseline-b2393','frutonyanya','Pipo-b2581','BRAND-S-b2632','hoff','Gullón-b2830','barbie','semper','Babybum-b2842','matilia','Tiniboo-b2950','Kokubo-b3015','Penaten-b2227','Pureen-b2240','goodhealth','merries','Lucky-Baby-b2353','kuku-duckbill','Pfizer-b2428','Yejimiin-b2431','lock-lock','winwin-toys','chuchu-baby','munchkin','supor','kodomo','bubchen','sunplay','Celia-b2249','Gallia-b2274','Born-Free-b2321','Konichi-b2450','chicco','Sassy-b2197','farlin','physiolac','combi','wakodo','bepanthen','aptamil','VNPOFOOD-b2325','goon','brevi','luvable-friends','unimom','Lignum-Vitae-b2479','dutch-lady','Miki-b2488','Muhi-b2492','haribo','kidsme','Hudson-Baby-b2638','yakult','uPang-b3093','sudocrem','Guarantee','Mio-Mio','babymoov','Masterkidz-b2741','biogaia','Rotho-Babydesign','Healthway','Pressed Purity','Tiny-Love-b2456','Mothercare-b2457','pororo','Ichiban-b2514','Devondale-b2572','Maruto-b2584','Wyeth-b2665','sai-gon-foods','pigeon','braun','Safety-1st-b2202','nestle','nuby','basilic','fatzbaby','laica','mustela','bobby','Lego-b2402','bledina','Kenjo-b2424','intex','duy-tan','Beurer-b2452','Long-Hưng-b2454','Kewpie-b2464','Graco-b2466','VBCare-b2476','Piyo-Piyo-b2483','meiji','Spectra-b2469','Baby-Dream-b2475','NutiFood-b2486','Anmum-b2490','namyang','mastela','bibo-s','microlife','moony','Carter-s-b2349','Raiya-b2369','toyroyal','mead-johnson','comotomo','Play-Doh-b2493','Winx-b2498','kiddy','Red Tractor Foods','cay-thi','bellamy-s-organic','momma-baby','Phuc-An','aag','chong-chong','bb-bag','pediasure','france-lait','lintimate','p-s','autoru','winfun','royalcare','Aprica-b2839','Guarantee-Care-b2857','avk','Super-Wings-b2869','My-Little-Pony-b2872','ecoiffier-b2878','Kibu-b2884','Green-Swan-Pharmaceuticals-b2905','Luvena-Fortuna-b2641','upass','Euky-Bear-b2720','P-tit-Louis-b2755','song-long','Kidiboo-b2791','Hatchimals-b2875','Baoli-Toys-b2917','Champion-Bear-b2956','Airphin-b2965','Veesano-b2359','Summer-Infant-b2360','poemy','heinz','IKEA-b2444','bosch','zaracos','LEC-b2511','hot-wheels','wesser','Hope-b2590','Just-For-Chef-b2495','gluck-baby','Bobini-b2553','Muesli-b2596','Baby-Care-b2599','le-gia','Dintel-b2614','Kitchoun-b2620','mamamy','Sanest-b2683','Oops-b2693','babyGap-b2623','con-bo-cuoi','Etic-b2749','137-degrees','Rosio-b2935','Nohoo-b2959','sato','Pagoda-b2977','nissin','huro','Suntory-b2980','charm','Elegant-Kids-2000-b3039','fysoline','HuBDIC-b3081','Kaloo-b3099','Dabur-b3102','natri-clorid','Momcare','baby-moby','ecoegg','joona-baby','anti-in','fedora','bobi-craft','nature-love-mere','wildalp','selip','moo-chews','Alete','vpmilk',' dentfine ','hola','evoluderm','Yoga-Sprout-b3054','Montaly-b3060','Shimaya','Cherie','Frist-Ware','bbcooker','Anymetre','hanh-phuc','EMCO','Oball',
'Matsuya','KAO','Mega-Bloks','Naforye-b2389','grand-noble','putti-atti','ajinomoto','woody','Hape','australia-s-own','kendamil','Dabur Amla','sankyo-toys','thien-long','vovo','bornfree','grow','moaz-bebe','doppelherz','biohealth','lavie','top-bright','kiwigarden','me-doan','azeta-bio','KAI-b3042','ander','Touched-by-Nature-b3051','Little-Tikes-b3090','baby-lab','dr-papie','Japi','sunta','nimo','Aricare-b2696','Konig-Kids-b2818','Ehrmann-b2848','zott','pharmalife-research','ikami','Tao-Kae-Noi-b2986','babe-b3007','Lafe-s-b3021','Lil-soft-Baby-b3036','elmie','rafferty-s-garden','tanita','yoomi','thien-minh-phuc','bonnichon','purelac','ekel','denovo','ama-time','saro','purite','gifrer','amico','royal-nature','joovy','zelda','men-no-sato','bebble','inochi','nutricia','thuyen-xua','masculan','massel','ispoon','sagami','cleansui','little-etoile-organic','Downy-b2547','KitKat-b2635','MumGuard-b2677','caryn','Aime-b2712','Sleek-b2718','Today-Baby-b2724','Kacakid-b2731','huile-toys','monte','Ovaltine-b2803','shiseido','playkids','cetaphil','nous','oral-clean','nano-bamboo','beeboo','Sappe','similac','blackmores','unidry','megmilk-snow-brand','natural-life','hoa-nang','boneco','new-zealand-gold','dg','herbs-of-gold','edison','bebesup','fresh-garden','sofflin','b-box','l-ange','bean-stalk','Nuticia','bioamicus','nishimura','golden-wing','nubone','Ona-Global','j-while','lookatme','yomit','Hikid','kose','Maxkona ','little-etoile','itsuki','goldgi','fortex','pun','vitatree','champ','lets-eco','avaler','pom-pom','kefii','nature-gift','Little-Treasure-b3048','Sense-Plus-b3087','master-art','pediakid','hoai-an','hoang-cung','Chillafish','I-Byeol','wonmom','Dantoy-b2480','Crevil','CMPS','servewell','nivea','pure','kin-cho','optibac','coolbaby','oli6','haihain','orihiro','kirin','lion','dk-pharma','dongil ','kotex','agusha','pur','Baby-Alive-b2866','Sapodill-b2914','Heizen-b2920','BeeSmart-b2932','aden-anais','Babyganics-b3018','gold','Mosquitan-b3030','unicharm','nappi','jack-n-jill','antona','BND','beiens','GINCHO','nutri-nest','everyday-baby','sanity','lactel','maternea','royal-ausnz','Fleur-Alpine-b2602','Futaba-b2650','Momma-b2656','Snickers-b2659','Tiross-b2730','burine','lien-a','Kerokid-b2761','Renewallife-b2797','baobaohao','sunlife','co-mem','cancer-council','SPLAT-b3075','nip','kinlee','k-mom','physiodose','Dr.Krizten','Pearl-Lilfe','Kissy','huong-que','mother-k','Merx','baby-einstein','dr-brown-s','akamama','hestia','kamidi','fixderma','roscela','orthomol','baby-steps','bonbebe','bambo-nature','aquahandy','Ildong-Foodis','Omega-king-kiddy','daiichi','anpaso','thuyen-xua-foods','calbee','kanro','hismart','Miu-Miu-b2815','Uek-b2953','hong-lam','Colligo-b3010','Spry-b3024','unobaby','Betagen','Elemis','Luki','Alango','Fancy','sahmyook-foods','dr-spock-organics','s-26-gold','joie','toy-s-house','n-choice','humana','lansinoh','bubs','ami','i-b-o','epco-foods','little-love','rabi','kutieskin','elevit','Batiste','bear','i-angel','maccaca','a2-milk','59s','pierrot','martin','akay',' spring-leaf','th-true-milk','lotte-foods','liushen','superfood-lab','banobagi','r-o-c-s','bremed','only-organic','biostime','unimat-riken','marimer','molfix','zoy-zoii','hegen','bibs','foodcare','humanwell',
'yobite','Bebest','eggbaby','Nadle','Glasslock-b2385','Thien-Viet','oz-farm','mabu-hikoji','maeil-dairies','heritage-mill','lolbaby','vitadairy','ubmom','uinlui','koita','papa','livespo','abena','dodie','nature-s-way','viet-nhat','cocayhoala','shinas','onoff','faminuts','fujiya','danalac','test'];
export const FunctionId=[1040, 979, 1038];

export const Home =['/khuyen-mai.html','/khuyen-mai','/nutriben.html','/maxcare.html','/the-first-year.html','/modilac.html','/perfect-purity.html','/vtech.html','/tommee-tippee.html','/nanny-vitacare.html','/vaseline.html','/pipo.html','/brand-s.html','/gullon.html','/babybum.html','/tiniboo.html','/kokubo.html','/penaten.html','/pureen.html','/lucky-baby.html','/pfizer.html','/yejimiin.html','/celia.html','/gallia.html','/born-free.html','/konichi.html','/sassy.html','/vnpofood.html','/lignum-vitae.html','/miki.html','/muhi.html','/hudson-baby.html','/upang.html','/guarantee.html','/masterkidz.html','/rotho-babydesign.html','/healthway.html','/pressed-purity.html','/tiny-love.html','/mothercare.html','/ichiban.html','/devondale.html','/maruto.html','/wyeth.html','/safety-1st.html','/lego.html','/kenjo.html','/beurer.html','/long-hung.html','/kewpie.html','/graco.html','/vbcare.html','/piyo-piyo.html','/spectra.html','/baby-dream.html','/nutifood.html','/anmum.html','/carter-s.html','/raiya.html','/play-doh.html','/winx.html','/red-tractor-foods.html','/bb-bag.html','/lintimate.html','/p-s.html','/aprica.html','/guarantee-care.html','/super-wings.html','/my-little-pony.html','/ecoiffier.html','/green-swan-pharmaceuticals.html','/euky-bear.html','/p-tit-louis.html','/kidiboo.html','/hatchimals.html','/baoli-toys.html','/champion-bear.html','/airphin.html','/veesano.html','/summer-infant.html','/ikea.html','/lec.html','/just-for-chef.html','/bobini.html','/muesli.html','/baby-care.html','/dintel.html','/kitchoun.html','/sanest.html','/oops.html','/babygap.html','/etic.html','/rosio.html','/nohoo.html','/pagoda.html','/suntory.html','/elegant-kids-2000.html','/hubdic.html','/kaloo.html','/dabur.html','/momcare.html','/bobi-craft.html','/nature-love-mere.html','/wildalp.html','/selip.html','/alete.html','/yoga-sprout.html','/montaly.html','/shimaya.html','/cherie.html','/frist-ware.html','/anymetre.html','/hanh-phuc.html','/emco.html','/oball.html','/matsuya.html','/kao.html','/mega-bloks.html','/naforye.html','/hape.html','/australia-s-own.html','/bornfree.html','/lavie.html','/kai.html','/ander.html','/touched-by-nature.html','/little-tikes.html','/japi.html','/aricare.html','/konig-kids.html','/ehrmann.html','/tao-kae-noi.html','/babe.html','/lafe-s.html','/lil-soft-baby.html','/elmie.html','/rafferty-s-garden.html','/tanita.html','/yoomi.html','/thien-minh-phuc.html','/bonnichon.html','/ekel.html','/denovo.html','/ama-time.html','/saro.html','/purite.html','/gifrer.html','/amico.html','/joovy.html','/zelda.html','/men-no-sato.html','/nutricia.html','/masculan.html','/sagami.html','/cleansui.html','/little-etoile-organic.html','/downy.html','/kitkat.html','/mumguard.html','/aime.html','/sleek.html','/today-baby.html','/kacakid.html','/ovaltine.html','/shiseido.html','/unidry.html','/natural-life.html','/hoa-nang.html','/boneco.html','/herbs-of-gold.html','/golden-wing.html','/lets-eco.html','/little-treasure.html','/sense-plus.html','/hoang-cung.html','/chillafish.html','/i-byeol.html','/dantoy.html','/crevil.html','/cmps.html','/servewell.html','/nivea.html','/kin-cho.html','/lion.html','/dongil.html','/kotex.html','/baby-alive.html','/sapodill.html','/heizen.html','/beesmart.html','/babyganics.html','/mosquitan.html','/bnd.html','/gincho.html','/everyday-baby.html','/sanity.html','/lactel.html','/maternea.html','/royal-ausnz.html','/fleur-alpine.html','/futaba.html','/snickers.html','/tiross.html','/kerokid.html','/renewallife.html','/splat.html','/dr-krizten.html','/pearl-lilfe.html','/kissy.html','/huong-que.html','/merx.html','/roscela.html','/baby-steps.html','/aquahandy.html','/miu-miu.html','/uek.html','/hong-lam.html','/colligo.html','/spry.html','/betagen.html','/luki.html','/alango.html','/fancy.html','/joie.html','/toy-s-house.html','/n-choice.html','/bubs.html','/ami.html','/i-b-o.html','/epco-foods.html','/maccaca.html','/59s.html','/martin.html','/th-true-milk.html','/liushen.html','/unimat-riken.html','/nadle.html','/Glasslock.html','/thien-viet.html','/oz-farm.html','/heritage-mill.html','/lolbaby.html','/uinlui.html','/koita.html','/papa.html','/dodie.html'];

export const Redirect = {'/sua-bot-cac-loai/sua-aptamil.html':'/sua-aptamil.html',
'/sua-aptamil-essensis.html':'/sua-aptamil.html',
'/sua-aptamil-new-zealand.html':'/sua-aptamil.html',
'/sua-enfa-my.html':'/sua-enfa.html',
'/sua-enfa-thai.html':'/sua-enfa.html',
'/sua-enfa-a2.html':'/sua-enfa.html',
'/bot-an-dam/bot-an-dam-wakodo.html':'/bot-an-dam-wakodo.html',
'/bot-an-dam/bot-an-dam-danalac.html':'/bot-an-dam-danalac.html',
'/banh-an-dam-maeil-dairies.html':'/banh-an-dam-maiel-dairies.html',
'/coc-binh-tap-uong.html':'/binh-tap-uong.html',
// '/bo-quan-ao-be-gai.html':'/bo-quan-ao.html',
'/mu-bo-vanh.html':'/mu-khan.html',
'/mu-luoi-trai.html':'/mu-khan.html',
'/mu-len.html':'/mu-khan.html',
'/khan-tam-giac.html':'/mu-khan.html',
'/phu-kien-thoi-trang/kinh-tre-em.html':'/kinh-tre-em.html',
'/goi-cao-su.html':'/goi.html',
'/goi-chong-bet-dau.html':'/goi.html',
'/goi-chan-cho-be.html':'/goi.html',
'/goi-om.html':'/goi.html',
'/cui-va-phu-kien.html':'/giuong-cui-va-phu-kien.html',
'/noi-mastela.html':'/noi-em-be.html',
'/noi-joie.html':'/noi-em-be.html',
'/dung-cu-hut-mui-cho-be.html':'/dung-cu-hut-mui.html',
'/be-tam-va-ve-sinh/sua-tam-goi-cho-be/sua-tam-goi-chicco.html':'/sua-tam-goi-chicco.html',
'/be-tam-va-ve-sinh/sua-tam-goi-cho-be/sua-tam-goi-pigeon.html':'/sua-tam-goi-pigeon.html',
'/be-tam-va-ve-sinh/sua-tam-goi-cho-be/sua-tam-goi-bubchen.html':'/sua-tam-goi-bubchen.html',
'/khan-mat.html':'/khan-mat-khan-tam.html',
'/khan-xo-khan-sua.html':'/khan-mat-khan-tam.html',
'/khan-tam-cho-be.html':'/khan-mat-khan-tam.html',
'/ao-choang-tam-cho-be.html':'/khan-mat-khan-tam.html',
'/ghe-ngoi-o-to-cho-be.html':'/xe-cho-be.html',
'/be-choi-va-hoc/do-choi-thong-minh/dat-nan-bot-nan.html':'/dat-nan-bot-nan.html',
'/do-choi-go.html':'/be-choi-va-hoc.html',
'/do-choi-winwin-toys.html':'/be-choi-va-hoc.html',
'/do-choi-colligo.html':'/be-choi-va-hoc.html',
'/thanh-chan-giuong.html':'/thiet-bi-bao-ve-an-toan.html',
// '/men-vi-sinh.html':'/cham-soc-suc-khoe-cho-be.html',
// '/may-hut-sua-fatzbaby.html':'/may-hut-s-a-fatzbaby.html',
'/maplist/index/':'/he-thong-cua-hang.html',
'/momma.html':'/momma-baby.html',
'/brand/hola.html':'/hola.html',
'/brand/top-bright.html':'/top-bright.html',
'/cancercouncil.html':'/cancer-council.html',
'/brand/kiwigarden.html':'/kiwigarden.html',
'/brand/bear.html':'/bear.html',
'/brand/akay.html':'/akay.html',
'/brand/vitadairy.html':'/vitadairy.html',
'/brand/ubmom.html':'/ubmom.html',
'/vpmilk':'/vpmilk.html',
'/yomit':'/yomit.html',
'/fortex':'/fortex.html',
'/pun':'/pun.html',
'/coolbaby':'/coolbaby.html',
'/anpaso':'/anpaso.html',
'/banobagi':'/banobagi.html',
'/r.o.c.s.':'/r-o-c-s.html',
'/biostime':'/biostime.html',
'/gioi-thieu-bibomart':'/gioi-thieu-bibomart.html',
'/maplist/index/index/id/1/':'/he-thong-cua-hang.html',
'/men-vi-sinh-10-chung-bioamicus-complete.html':'/men-vi-sinh-10-chung-bioamicus-complete-10ml.html',
'/tra-thao-duoc-cu-gai-an-thai-an-thai-phuong.html':'/tra-thao-duoc-cu-gai-an-thai-phuong.html',
'/sua-grand-noble.html':'/sua-cho-be.html',
'/be-uong.html':'/sua-cho-be.html',
'/sua-similac.html':'/sua-cho-be.html',
'/sua-goodhealth.html':'/sua-cho-be.html',
'/sua-s26.html':'/sua-cho-be.html',
'/sua-wakodo.html':'/sua-cho-be.html',
'/sua-i-am-mother.html':'/sua-cho-be.html',
'/sua-friso.html':'/sua-cho-be.html',
'/sua-vinamilk.html':'/sua-cho-be.html',
'/be-tam-va-ve-sinh.html':'/bim-ta-va-ve-sinh.html',
'/be-uong-sua.html':'/sua-cho-be.html',
'/dung-cu-tru-sua-ham-sua.html':'/may-ham-sua.html',
'/ve-sinh-binh-sua.html':'/nuoc-rua-binh-sua.html',
'/be-an-dam.html':'/an-dam-dinh-duong.html',
'/bot-an-dam-wakodo.html':'/bot-an-dam.html',
'/bot-an-dam-kendamil.html':'/bot-an-dam.html',
'/bot-an-dam-nestle.html':'/bot-an-dam.html',
'/chao-an-dam-wakodo.html':'/my-chao-an-dam.html',
'/vang-sua-pho-mai-sua-chua.html':'/vang-sua.html',
'/thuc-pham-an-dam-khac.html':'/gia-vi-an-dam.html',
'/keo-cho-be.html':'/keo-banh-dinh-duong.html',
'/dung-cu-tap-an-tap-uong.html':'/bat-thia-dia.html',
'/yem-an-cho-be.html':'/yem-an-dam.html',
'/yem-mang.html':'/yem-an-dam.html',
'/yem-dan-khuy-bam.html':'/yem-an-dam.html',
'/do-dung-cho-be-an-dam-khac.html':'/do-dung-cho-be-an-dam.html',
'/binh-giu-nhiet.html':'/tui-giu-nhiet.html',
'/be-mac.html':'/thoi-trang-va-phu-kien.html',
'/do-so-sinh-cho-be.html':'/do-so-sinh.html',
'/bao-chan-bao-tay.html':'/bao-tay.html',
'/ta-vai.html':'/do-so-sinh.html',
'/phu-kien-khac.html':'/phu-kien-thoi-trang.html',
'/be-ngu.html':'/do-dung-be-ngu.html',
'/chan-dem-ga-goi.html':'/do-dung-be-ngu.html',
'/ghe-rung-cho-be.html':'/do-dung-me-va-be.html',
'/ghe-rung-mastela.html':'/do-dung-me-va-be.html',
'/noi-em-be.html':'/noi-dien-cui-go.html',
'/noi-autoru.html':'/noi-dien-cui-go.html',
'/bim-goon-ta-goon.html':'/bim-ta-va-ve-sinh.html',
'/ban-chai-kem-danh-rang.html':'/kem-danh-rang.html',
'/dung-cu-ve-sinh-cho-be.html':'/ve-sinh-ca-nhan-cho-be.html',
'/sua-tam-goi-chicco.html':'/sua-tam-goi-cho-be.html',
'/sua-tam-goi-pigeon.html':'/sua-tam-goi-cho-be.html',
'/sua-tam-goi-bubchen.html':'/sua-tam-goi-cho-be.html',
'/bot-giat-nuoc-xa-vai.html':'/nuoc-giat-xa.html',
'/nuoc-giat-arau-baby.html':'/nuoc-giat-xa.html',
'/be-di-choi-va-van-dong.html':'/xe-cho-be.html',
'/xe-day-seebaby.html':'/xe-day.html',
'/xe-day-vovo.html':'/xe-day.html',
'/xe-day-gluck.html':'/xe-day.html',
'/xe-day-baobaohao.html':'/xe-day.html',
'/xe-day-combi.html':'/xe-day.html',
'/xe-lac-xe-choi-chan.html':'/xe-lac.html',
'/xe-va-phu-kien-van-dong-khac.html':'/xe-cho-be.html',
'/xe-may-dien-tre-em.html':'/xe-cho-be.html',
'/phao-boi.html':'/do-boi-cho-be.html',
'/be-boi-phao.html':'/do-boi-cho-be.html',
'/do-choi-hoc-tap.html':'/do-choi-thong-minh.html',
'/do-choi-mo-hinh-dieu-khien.html':'/do-choi-dieu-khien.html',
'/do-choi-huong-nghiep.html':'/do-choi-nhap-vai.html',
'/be-khoe-va-an-toan.html':'/vitamin-va-suc-khoe.html',
'/tu-thuoc-gia-dinh.html':'/vitamin-va-suc-khoe.html',
'/nhiet-ke-microlife.html':'/nhiet-ke-cho-be.html',
'/cham-soc-suc-khoe-cho-be.html':'/vitamin-va-suc-khoe.html',
'/thuc-pham-chuc-nang.html':'/vitamin-cho-be.html',
'/khan-lau-ha-sot.html':'/mieng-dan-ha-sot.html',
'/sua-similac-mom.html':'/sua-ba-bau.html',
'/sua-frisomum.html':'/sua-ba-bau.html',
'/may-hut-sua-tui-tru-sua.html':'/may-hut-sua.html',
'/may-hut-s-a-fatzbaby.html':'/may-hut-sua.html',
'/do-dung-cho-me-khac.html':'/me-bau-va-sau-sinh.html',
'/do-dung-khac.html':'/me-bau-va-sau-sinh.html',
'/bim-cho-me-sau-sinh.html':'/bim-bang-ve-sinh.html',
'/lam-dep-sau-sinh.html':'/my-pham-cho-me.html',
'/do-dung-trong-nha.html':'/cham-soc-gia-dinh.html',
'/dung-cu-nha-bep.html':'/cham-soc-gia-dinh.html',
'/do-dung-trong-nha-khac.html':'/cham-soc-gia-dinh.html',
'/tu-nhua-duy-tan.html':'/tu-nhua.html',
'/quat-cam-tay.html':'/cham-soc-gia-dinh.html',
'/nhiet-am-ke.html':'/cham-soc-gia-dinh.html',
'/tu-nhua-cho-be.html':'/tu-nhua.html',
'/danh-cho-me.html':'/me-bau-va-sau-sinh.html',
'/giuong-cui-va-phu-kien.html':'/noi-dien-cui-go.html',
'/binh-sua-pigeon-ppsu-plus-wn3-hinh-cay-160ml.html':'/binh-sua-pigeon-ppsu-plus-wn3-160ml.html',
'/binh-sua-pigeon-ppsu-plus-wn3-hinh-ga-con-160ml.html':'/binh-sua-pigeon-ppsu-plus-wn3-160ml.html',
'/binh-sua-pigeon-ppsu-plus-wn3-hinh-ngoi-sao-160ml.html':'/binh-sua-pigeon-ppsu-plus-wn3-160ml.html',
'/binh-sua-pigeon-ppsu-plus-wn3-hinh-cay-240ml.html':'/binh-sua-pigeon-ppsu-plus-wn3-240ml.html',
'/binh-sua-pigeon-ppsu-plus-wn3-hinh-ga-con-240ml.html':'/binh-sua-pigeon-ppsu-plus-wn3-240ml.html',
'/binh-sua-pigeon-pp-tieu-chuan-hinh-gau-120ml.html':'/binh-sua-pigeon-pp-tieu-chuan-120ml.html',
'/binh-sua-pigeon-pp-tieu-chuan-hinh-hamster-120ml.html':'/binh-sua-pigeon-pp-tieu-chuan-120ml.html',
'/binh-sua-pigeon-pp-tieu-chuan-hinh-gau-240ml.html':'/binh-sua-pigeon-pp-tieu-chuan-240ml.html',
'/binh-sua-pigeon-pp-tieu-chuan-hinh-hamster-240ml.html':'/binh-sua-pigeon-pp-tieu-chuan-240ml.html',
'/binh-sua-pigeon-softouch-plus-ppsu-ngoi-sao-160ml.html':'/binh-sua-pigeon-softouch-plus-ppsu-160ml.html',
'/binh-sua-pigeon-softouch-plus-ppsu-thu-cung-160ml.html':'/binh-sua-pigeon-softouch-plus-ppsu-160ml.html',
'/binh-sua-pigeon-ppsu-plus-hinh-thu-kangaroo-160ml.html':'/binh-sua-pigeon-softouch-plus-ppsu-160ml.html',
'/binh-sua-pigeon-softouch-plus-ppsu-ngoi-sao-240ml.html':'/binh-sua-pigeon-ppsu-plus-240ml.html',
'/binh-sua-pigeon-softouch-plus-ppsu-thu-cung-240ml.html':'/binh-sua-pigeon-ppsu-plus-240ml.html',
'/num-ty-avent-3-lo-3m-vi-doi-653-23.html':'/binh-sua-pigeon-softouch-t-ester-plus-300ml.html',
'/num-ty-avent-4-lo-6m-vi-doi-654-23.html':'/binh-sua-pigeon-softouch-t-ester-plus-300ml.html',
'/binh-sua-silicon-putti-atti-mau-xanh-260ml.html':'/binh-sua-silicone-puttiatti-260ml.html',
'/binh-sua-silicon-putti-atti-mau-hong-260ml.html':'/binh-sua-silicone-puttiatti-260ml.html',
'/binh-sua-silicon-putti-atti-mau-xanh-160ml.html':'/binh-sua-tay-cam-puttiatti-160ml.html',
'/binh-sua-silicon-putti-atti-mau-hong-160ml.html':'/binh-sua-tay-cam-puttiatti-160ml.html',
'/num-ty-comotomo-hop-2-chiec-tren-6-thang.html':'/num-ty-comotomo-hop-2-chiec.html',
'/num-ty-comotomo-hop-2-chiec-tren-3-thang.html':'/num-ty-comotomo-hop-2-chiec.html',
'/binh-sua-silicon-gluck-premium-mau-xanh-150ml.html':'/binh-sua-silicon-gluck-premium-150ml.html',
'/binh-sua-silicon-gluck-premium-mau-hong-150ml.html':'/binh-sua-silicon-gluck-premium-150ml.html',
'/binh-sua-silicon-gluck-premium-mau-cam-150ml.html':'/binh-sua-silicon-gluck-premium-150ml.html',
'/sua-aptamil-new-zealand-so-1-900g-0-12-thang.html':'/sua-aptamil.html',
'/sua-aptamil-new-zealand-so-2-900g-12-24-thang.html':'/sua-aptamil.html'
}
export const DefaultImg = '/images/noimg.jpg';


export const chunkArray = (arr, size) => {
  return arr.reduce((chunks, el, i) => {
    if (i % size === 0) {
      chunks.push([el]);
    } else {
      chunks[chunks.length - 1].push(el);
    }
    return chunks;
  }, []);
}